/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![EyeDropperIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABaElEQVR4nM2VO0oDURSGZwmKop2vPYiVLsDMeUwgc06CIgYrLVJql6BLsLDPAsQN+NiDtlEiVmmsdJrAyEUTo5ncuddB9IfDwMB8/3nNvUHw3xWG1VkgOUPWLrI+IWt7s1xb9AaVSrVpRF0j2pkavCOSJSTpIGv6JUh7YVhZcIYjSwNJkvePzVMaBg6sD2Pwz2i7wSM9yAIAy7MFngLrYyEDzI975xYBScvbgPTU2cDbhKTDvD0T+ApIDh0MuqVybcULTFTdQ9Z6XiVm8Ga7fLM+GQJIWnkmZoWd4ch6PJZlnglJMvoz2jKf3Aqym4RRvJqXedNhmPUsEyB9tVbguCkpYrybXa1lBojxBpD28+Dw0aJRhVTdN2FvDemFQ/ZNK2Ria0DnhyemR+ZOAqgsI8vdr8CNkORmMlj7yHIUFFFma0gSYDknkvWgqID1+ttRextFW3OFwQOZSxpYr5D1BUkuf3Rp/5XeAG7dxWng2ZMHAAAAAElFTkSuQmCC)
 */
export const EyeDropperIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="m16.25 2.25-2 2-.63-.63a3 3 0 0 0-4.24 0l-.85.85c-.3.3-.3.77 0 1.06l9.94 9.94c.3.3.77.3 1.06 0l.85-.85a3 3 0 0 0 0-4.24l-.63-.63 2-2a3.89 3.89 0 1 0-5.5-5.5ZM9.3 9.7a1 1 0 0 1 1.4 0l3.6 3.6a1 1 0 0 1 0 1.4l-4.84 4.84a5 5 0 0 1-2.7 1.39c-.47.08-.86.42-1.1.83a2.5 2.5 0 1 1-3.42-3.42c.41-.24.75-.63.83-1.1a5 5 0 0 1 1.4-2.7L9.28 9.7Z"
        className={colorClass}
      />
    </svg>
  );
};
